import React, { Component } from "react";
import { FaCocktail, FaHiking, FaShuttleVan, FaBeer } from "react-icons/fa";
import Title from "./Title";

export default class Services extends Component {
  state = {
    services: [
      {
        icon: <FaCocktail />,
        title: "free cocktails",
        info:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam suscipit, lorem vel tristique tempor, risus felis commodo quam, eget porta tortor tellus ut purus."
      },
      {
        icon: <FaHiking />,
        title: "Endless hiking",
        info:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam suscipit, lorem vel tristique tempor, risus felis commodo quam, eget porta tortor tellus ut purus."
      },
      {
        icon: <FaShuttleVan />,
        title: "free shuttle",
        info:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam suscipit, lorem vel tristique tempor, risus felis commodo quam, eget porta tortor tellus ut purus."
      },
      {
        icon: <FaBeer />,
        title: "Strongest Beer",
        info:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam suscipit, lorem vel tristique tempor, risus felis commodo quam, eget porta tortor tellus ut purus."
      }
    ]
  };
  render() {
    return (
      <section className="services">
        <Title title="services" />
        <div className="services-center">
          {this.state.services.map((item, index) => {
            return (
              /* pay attention to index as key */
              <article key={index} className="service">
                <span>{item.icon}</span>
                <h6>{item.title}</h6>
                <p>{item.info}</p>
              </article>
            );
          })}
        </div>
      </section>
    );
  }
}
